import { AdvancedDomainCheck, DomainFraudChecks } from './getGroupedFraudChecks'

const BASIC_CHECK_FAILURE_CONFIG: Record<string, { property: string; failsWhen: boolean }> = {
  can_website_be_opened: { property: 'canBeOpened', failsWhen: false },
  disallowed_domain_list: { property: 'isDisallowed', failsWhen: true },
  has_website_hosting_provider_subdomain: { property: 'hasWebsiteHostingProviderSubdomain', failsWhen: true },
  has_website_placeholder_content: { property: 'hasWebsitePlaceholderContent', failsWhen: true },
  has_website_redirect: { property: 'hasWebsiteRedirect', failsWhen: true },
  is_ssl_certificate_valid: { property: 'isSslCertificateValid', failsWhen: false },
  is_website_empty: { property: 'isWebsiteEmpty', failsWhen: true },
  has_free_hosting_cname: { property: 'hasFreeHostingCname', failsWhen: true },
  has_high_risk_tld: { property: 'isHighRisk', failsWhen: true },
  website_legitimacy_analysis: { property: 'isWebsiteLegitimate', failsWhen: false },
  has_country_tld_mismatch: { property: 'isMismatch', failsWhen: true },
  has_email_domain_redirect_to_organisation: { property: 'hasEmailDomainRedirectToOrganisation', failsWhen: true }
}

const isBasicCheckFailed = (check: { checkName: string; data: Record<string, unknown> }): boolean => {
  const config = BASIC_CHECK_FAILURE_CONFIG[check.checkName]

  if (!config) return false

  return check.data[config.property] === config.failsWhen
}

type AdvancedDomainFlag = NonNullable<AdvancedDomainCheck['data']['flags']>[number]

type FailedAdvancedDomainCheck = {
  name: AdvancedDomainFlag | `${AdvancedDomainCheck['checkName']}_failed`
  weight: number
}

export const getFailedDomainAutoChecks = (fraudChecks: DomainFraudChecks | undefined) => {
  const advancedChecks = fraudChecks?.advanced.flatMap<FailedAdvancedDomainCheck>(c => {
    if (c.data.flags?.length) return c.data.flags.map(flag => ({ name: flag, weight: c.weight }))

    // The API can fail an advanced check without any flags, so the check itself is the flag
    if (c.result === 'fail') return [{ name: `${c.checkName}_failed` as const, weight: c.weight }]

    return []
  })
  const basicChecks = fraudChecks?.basic.filter(isBasicCheckFailed).map(c => ({ name: c.checkName, weight: c.weight }))

  return {
    advanced: advancedChecks,
    basic: basicChecks,
    total: (advancedChecks?.length ?? 0) + (basicChecks?.length ?? 0)
  }
}

export type FailedDomainAutoChecks = ReturnType<typeof getFailedDomainAutoChecks>
